<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    蛇口港站<br>
站点介绍<br>
蛇口港站站位于深圳市南山区蛇口港客运码头旁，港湾大道南侧，车站呈西南至东北走向。车站周围有新邮轮中心公交接驳点（蛇口港客运码头旧，已搬离）。（蛇口海关。无此项）该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:58	00:38	2号线	2分35秒	5分45秒<br>
莲塘	06:07	23:02	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	07:03	00:37	2号线	4分钟	5分钟<br>
莲塘	06:07	23:02	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	07:03	01:27	2号线	4分钟	5分钟<br>
莲塘	06:07	00:02	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
C出入口:<br>
港湾大道（东）、南海大道、蛇口邮轮中心<br><br>
D1出入口:<br>
港湾大道（西）、蛇口交警大队<br><br>
公交换乘信息<br><br>
C出入口:<br>
公交站名： 蛇口港地铁站公交总站<br>
B601<br><br>
D1出入口:<br>
公交站名： 蛇口港地铁站<br>
22、70、113、122、204、226、331、M105、M106、M400、M409、M430、M448<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>